import React, { useState } from "react"
import { useConsultantDetailsContext } from "../ConsultantDetails"
import { IGetDetailsConsultant } from "../core/_models"
import { useConsultant } from "../../core/useConsultant"
import { useQueryClient } from "react-query"
import { toast } from "react-toastify"
import MyModal from "@common-utils/MyModal"
import EnvoyerOuIgnorerEnvoiDocEmbauche from "../../../../../components/consultant/EnvoyerOuIgnorerEnvoiDocEmbauche"

const ConsultantDetailsAlerteEnvoiOuIgnorerDocEmbauche = () => {
     const queryClient = useQueryClient()
     const { documentsEmbaucheIgnorerEnvoi } = useConsultant()
     const { detailsQuery, REACT_QUERY_KEY_GET_CONSULTANT_DETAILS } = useConsultantDetailsContext()

     const data = detailsQuery.data as IGetDetailsConsultant
     const consultant = data.consultant!

     const [isReadyToSendDocsThroughModal, setIsReadyToSendDocsThroughModal] = useState(false)

     function onSuccessIgnorerEnvoi() {
          const success = () => {
               queryClient.setQueryData<IGetDetailsConsultant | undefined>(REACT_QUERY_KEY_GET_CONSULTANT_DETAILS, (prev: IGetDetailsConsultant | undefined) => {
                    if (prev) return { ...prev, consultant: { ...prev.consultant, docEmbaucheEnvoye: false } }
                    return prev
               })

               toast.success("Votre action a bien été prise en compte.")
          }

          documentsEmbaucheIgnorerEnvoi(
               consultant,
               () => {},
               () => success()
          )
     }

     function onSuccessEnvoi() {
          queryClient.setQueryData<IGetDetailsConsultant | undefined>(REACT_QUERY_KEY_GET_CONSULTANT_DETAILS, (prev: IGetDetailsConsultant | undefined) => {
               if (prev) return { ...prev, consultant: { ...prev.consultant, docEmbaucheEnvoye: true, docEmbaucheEnvoyeDate: new Date() } }
               return prev
          })

          setIsReadyToSendDocsThroughModal(false)
          toast.success("Votre action a bien été prise en compte.")
     }

     return (
          <>
               <div className="alert alert-warning text-gray-700 fw-bold">
                    <div className="fs-5 mb-2 d-flex align-items-center">
                         <i className="fas fa-file-signature me-2 text-warning"></i>
                         <span className="text-warning">Documents d’embauche</span>
                    </div>

                    <div>
                         Les documents d’embauche n’ont pas encore été envoyés depuis Talent. Vous pouvez les transmettre dès maintenant :
                         <span className="text-primary ms-1 text-pulse cursor-pointer text-hover-dark" onClick={() => setIsReadyToSendDocsThroughModal(true)}>
                              Envoyer les documents <span className="fas fa-paper-plane" />
                         </span>
                    </div>

                    <div className="mt-2">
                         Si vous ne souhaitez pas procéder à l’envoi, vous pouvez désactiver cette alerte :
                         <span className="text-danger ms-1 text-pulse cursor-pointer text-hover-dark" onClick={onSuccessIgnorerEnvoi}>
                              Ignorer l’envoi <span className="fas fa-times-circle" />
                         </span>
                    </div>
               </div>

               {isReadyToSendDocsThroughModal && (
                    <MyModal
                         titleMiddle={<span className={"fw-bold fs-2"}>Envoi des documents d'embauche</span>}
                         show={isReadyToSendDocsThroughModal}
                         onCloseCallback={() => setIsReadyToSendDocsThroughModal(false)}
                         size={"lg"}
                    >
                         <EnvoyerOuIgnorerEnvoiDocEmbauche consultant={consultant} onSuccessEnvoyerDocCallback={onSuccessEnvoi} isIgnorerButtonHidden={true} />
                    </MyModal>
               )}
          </>
     )
}

export default ConsultantDetailsAlerteEnvoiOuIgnorerDocEmbauche
